import { render, staticRenderFns } from "./AsPartPopupTable.vue?vue&type=template&id=b8f745c8&"
import script from "./AsPartPopupTable.vue?vue&type=script&lang=js&"
export * from "./AsPartPopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports